module.exports = __webpack_public_path__ + "img/dk.af75c6b4.svg";